import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { StoryTheme } from '../model/story/story-theme.model';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private httpClient = inject(HttpClient);

  public getThemeList(): Observable<StoryTheme[]> {
    return this.httpClient.get<any[]>(
      `${environment.apiUrl}/api/themas`,
    ).pipe(
      map((responseList: any[]): StoryTheme[] => (responseList ?? []).map(
        (response:any): StoryTheme => StoryTheme.createFromApi(response),
      )),
    );
  }
}
